let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iDFLQ")).then(() => parcelRequire('2CfbW'));